export default __webpack_public_path__ + "static/media/icon2.45e10821.svg";